import { EEecsRegistry } from 'types';

export enum EConfirmationStatus {
  DISABLED = 'disabled',
  FIRST_SIGNATORY = 'first_signatory',
  SECOND_SIGNATORY = 'second_signatory',
  ALL = 'all',
}

export interface IExchangeSettingsUser {
  id: number;
  name: string;
  email: string;
  title: string;
}

export interface IExchangeSettings {
  representative_user: IExchangeSettingsUser | null;
  first_signatory_user: IExchangeSettingsUser | null;
  second_signatory_user: IExchangeSettingsUser | null;
  auto_assignment_forwards: boolean;
  incoming_registry?: EEecsRegistry | null;
  show_orders_on_exchange: boolean;
  confirmation_status: EConfirmationStatus;
}

export interface ExchangeSettingPayload {
  representative_user_id: number;
  first_signatory_user_id: number;
  first_signatory_title: string;
  second_signatory_user_id?: number;
  second_signatory_title?: string;
  auto_assignment_forwards: boolean;
  incoming_registry: EEecsRegistry;
  confirmation_status: EConfirmationStatus;
}

export interface ExchangeOrdersVisibilityPayload {
  show_orders_on_exchange: boolean;
}
